import React from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Input } from '../page-components/Input';
import { Label } from '../page-components/Label';

interface Props {
	onSelectFile: (e: any) => void;
	onEditFile: () => void;
	onDeleteFile: () => void;
	uploadedFile: string | undefined;
	isDisable: boolean;
	formik: any;
	isAdmin: boolean;
	label: string;
	fieldName: string;
	additionalClass: string;
	imageAdditionalClass: string;
	isWidgetPage?: boolean
}

export const UploadLogo = (props: Props): React.ReactElement => {
	const {
		onSelectFile,
		uploadedFile,
		onEditFile,
		onDeleteFile,
		isDisable,
		formik,
		isAdmin,
		label,
		fieldName,
		additionalClass,
		imageAdditionalClass,
		isWidgetPage
	} = props;
	const { t } = useTranslation();
	return (
		<div className={clsx('position-relative', !isAdmin && 'mb-5', additionalClass)}>
			<Label
				fieldLabel={label}
				additionalClass="fw-bold cursor-pointer position-relative"
				isStandardClass
			>
				<>
					<Input
						inputType="file"
						onSelectFile={onSelectFile}
						uploadedFile={uploadedFile}
						imageAdditionalClass={imageAdditionalClass}

					/>
					<Whisper
						trigger="hover"
						placement="top"
						speaker={
							<Tooltip>{t('COLOR_MODULE.UPLOAD_BTN_TOOLTIP')}</Tooltip>
						}
					>
						<div
							className="position-absolute download-wrapper wrapper-icon cursor-pointer"
							onClick={onSelectFile}
						>
							<FontAwesomeIcon icon={faUpload} className="upload-icon"/>
						</div>
					</Whisper>
				</>
			</Label>
			<div className="text-muted fs-8">
				{t('COLOR_MODULE.FILE_TYPES')}
			</div>

			<Whisper
				trigger="hover"
				placement="top"
				speaker={
					<Tooltip>{t('COLOR_MODULE.CROP_BTN_TOOLTIP')}</Tooltip>
				}
			>
				<div
					className={clsx('position-absolute wrapper-icon',
						isWidgetPage ? 'edit-wrapper' : 'edit-wrapper-app',
						formik.values[fieldName] && isDisable ? 'cursor-pointer' : 'cursor-not-allowed'
					)}
					onClick={onEditFile}
				>
					<FontAwesomeIcon icon={faPenToSquare} className="edit-icon"/>
				</div>
			</Whisper>

			<Whisper
				trigger="hover"
				placement="top"
				speaker={
					<Tooltip>{t('COLOR_MODULE.DELETE_BTN_TOOLTIP')}</Tooltip>
				}
			>
				<div
					className={clsx('position-absolute wrapper-icon',
						isWidgetPage ? 'trash-wrapper' : 'trash-wrapper-app',
						uploadedFile ? 'cursor-pointer' : 'cursor-not-allowed'
					)}
					onClick={onDeleteFile}
				>
					<FontAwesomeIcon icon={faTrash} className="trash-icon"/>
				</div>
			</Whisper>

		</div>
	);
};
